import { initializeApp } from 'firebase/app';
//import { getFirestore, collection, getDocs, addDoc  } from "firebase/firestore";
import { firebaseConfig } from './FirebaseConfig';
import { getAuth, signInAnonymously } from 'firebase/auth';
import { getFunctions, httpsCallable } from 'firebase/functions';

class FirebaseClient {
    constructor() {
      const app = initializeApp(firebaseConfig);
      //this.db = getFirestore(app);
      const auth = getAuth(app);
      this.auth = auth;
      this.functions = getFunctions(app)
    }
  
    async sendRequest(email, requestType, additionalInfo) {
      const sendDeletionRequest = httpsCallable(this.functions, 'sendDeletionRequestFactSense');

      try {
        const response = await sendDeletionRequest({ email, requestType, additionalInfo});
        console.log("Function Response:", response.data);
        //alert(result.data.message);
        const result = {
          success: response.data.success,
          message: response.data.message
        }
        return result
      } catch (error) {
        //alert('Error: ' + error.message);
        const result = {
          success: false,
          message: "server side error"
        }
        console.error("Error sending request: ", error);
        return result
      }
    }

    async sendDeletionRequest2(email, requestType, additionalInfo) {
      // Get the current user and their ID token
      //const currentUser = this.auth.currentUser;

      try {
        // Authenticate anonymously
        const userCredential = await signInAnonymously(this.auth);
        console.log("User signed in anonymously:", userCredential.user.uid);

        const idToken = await userCredential.user.getIdToken();
  
        const response = await fetch(
            "https://us-central1-checkdiy-3a732.cloudfunctions.net/sendDeletionRequestFactSense",
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${idToken}`,
                },
                body: JSON.stringify({
                    email,
                    requestType,
                    additionalInfo,
                }),
            }
        );

        // Call the function
       // const sendDeletionRequest = httpsCallable(this.functions, "sendDeletionRequestCheckDIY");
        //const response = await sendDeletionRequest(data);

        console.log("Function Response:", response.data);
        const result = {
          success: response.data.success,
          message: response.data.message
        }

        return result;
        } catch (error) {
            console.error("Error during authentication or function call:", error);
            
            const result = {
              success: false,
              message: error.message
            }
            return result;
        }
      //if (!currentUser) {
      //    throw new Error("User is not authenticated");
      //}
  /*
      const idToken = await currentUser.getIdToken();
  
      const response = await fetch(
          "https://us-central1-checkdiy-3a732.cloudfunctions.net/sendDeletionRequest",
          {
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
                  "Authorization": `Bearer ${idToken}`,
              },
              body: JSON.stringify({
                  userEmail,
                  userRequestType,
                  additionalInfo,
              }),
          }
      );
  
      if (!response.ok) {
          const error = await response.json();
          throw new Error(error.message);
      }
  
      return response.json();
      */
  }
  

    async authenticateAndSendRequest(email, requestType, additionalInfo) {
      console.log("email: ", email);
      console.log("requestType: ", requestType);
      console.log("additionalInfo: ", additionalInfo);
      // Prepare data object
      const data = {
        userEmail: email,
        userRequestType: requestType,
        additionalInfo: additionalInfo
      };

      try {
          // Authenticate anonymously
          const userCredential = await signInAnonymously(this.auth);
          console.log("User signed in anonymously:", userCredential.user.uid);
  
          // Call the function
          const sendDeletionRequest = httpsCallable(this.functions, "sendDeletionRequestCheckDIY");
          const response = await sendDeletionRequest(data);
  
          console.log("Function Response:", response.data);
          return response.data;
      } catch (error) {
          console.error("Error during authentication or function call:", error);
          throw error;
      }
    }
      

    async sendMessage(email, enquiryType, message) {
      const sendMessageOver = httpsCallable(this.functions, 'sendMessageOverFactSense');
      try {
        const response = await sendMessageOver({ email, enquiryType, message });
        const result = {
          success: response.data.success,
          message: response.data.message
        }
        return result
      } catch (error) {
        console.error("Error sending message: ", error);
        const result = {
          success: false,
          message: `server side error: ${error.message}`
        }
        return result
      }
    }
/*
    async signInAnonymously(email, password) {
      try {
        const userCredential = await signInAnonymously(this.auth);
        console.log('User signed in anonymously');
      } catch (e) {
        console.error("Error signing in: ", e);
      }
    }
      */
  }
  
  const firebaseClient = new FirebaseClient(firebaseConfig);
  export default firebaseClient;